import * as React$1 from "react";
import { createPortal } from "react-dom";
//#region src/Portal/index.tsx
const Portal = ({ children, container: containerProp }) => {
	const [mounted, setMounted] = React$1.useState(false);
	React$1.useEffect(() => {
		setMounted(true);
	}, []);
	const container = containerProp || (mounted && typeof document !== "undefined" ? document.body : null);
	if (!container) return null;
	return createPortal(children, container);
};
//#endregion
export { Portal };

//# sourceMappingURL=index.js.map